import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { FormSchema } from '@/administration/pages/Journey/common/modals/LiveEventModal';
import { FormTitle } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormTitle';
import { FormCoverImage } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormCoverImage';
import { FormTimezone } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormTimezone';
import { ParticipantsInfoBanner } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/ParticipantsInfoBanner';
import { FormDescription } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormDescription';
import { FormLocation } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormLocation';
import { FormDate } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormDate';
import { FormStartsAt } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormStartsAt';
import { FormEndsAt } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormEndsAt';
import { DurationInformer } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/DurationInformer';
import { FormRecording } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormRecording/FormRecording';

const RootStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const HeaderStyled = styled.div`
  padding-bottom: 8px;
`;

const DateTimeContainerStyled = styled.div`
  display: flex;
  gap: 8px;
`;

const TimeContainerStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`;

const SeparatorStyled = styled.span`
  height: 42px;
  display: flex;
  align-items: center;
`;

export const LiveEventForm = ({
  spaceId,
  locationId,
  eventEndTime,
}: {
  spaceId: number;
  locationId?: number;
  eventEndTime?: string;
}): JSX.Element => {
  const { control } = useFormContext<FormSchema>();

  return (
    <RootStyled>
      <HeaderStyled>
        <FormCoverImage control={control} spaceId={spaceId} />
      </HeaderStyled>
      <FormTitle control={control} />
      <FormTimezone control={control} />
      <DateTimeContainerStyled>
        <FormDate control={control} />
        <TimeContainerStyled>
          <FormStartsAt control={control} />
          <SeparatorStyled>{'-'}</SeparatorStyled>
          <FormEndsAt control={control} />
        </TimeContainerStyled>
        <DurationInformer />
      </DateTimeContainerStyled>
      <FormLocation control={control} />
      <FormDescription control={control} spaceId={spaceId} />
      <FormRecording locationId={locationId} eventEndTime={eventEndTime} spaceId={spaceId} />
      <ParticipantsInfoBanner />
    </RootStyled>
  );
};
